import { render } from "./ImageLoadComponent.vue?vue&type=template&id=5dc0a6b8&scoped=true"
import script from "./ImageLoadComponent.vue?vue&type=script&lang=js"
export * from "./ImageLoadComponent.vue?vue&type=script&lang=js"

import "./ImageLoadComponent.vue?vue&type=style&index=0&id=5dc0a6b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc0a6b8"]])

export default __exports__